import React, { useEffect } from "react";
import "./App.scss";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AppProvider } from "./core/state/provider/AppProvider";
import WelcomeView from "./views/IleeroWebsite/WelcomeView";
import NotificationMessageRenderer from "./views/shared/NotificationMessageRender";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";
import localStorageKeys from "./core/constants/local-storage-keys";
import CookieConsent from "react-cookie-consent";
import ReactGA from "react-ga";
import AboutUs from "./views/IleeroWebsite/AboutUs";
import LandingPageNav from "./views/shared/LandingPageNav";
import Footer from "./views/IleeroWebsite/components/Footer";
import PrivacyPolicy from "./views/IleeroWebsite/PrivacyPolicy";
import TermsAndConditions from "./views/IleeroWebsite/TermsAndConditions";
import CompliancePolicy from "./views/IleeroWebsite/CompliancePolicy";
import Feedback from "./views/IleeroWebsite/Feedback";
import RequestDeletion from "./views/IleeroWebsite/RequestDeletion";

localStorage.setItem(localStorageKeys.batchId, uuidv4());

const App = () => {
  useEffect(() => {
    ReactGA.initialize("UA-208061906-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      <AppProvider>
        <LandingPageNav />
        <BrowserRouter>
          <NotificationMessageRenderer />
          <Switch>
            <Route exact path="/">
              <WelcomeView />
            </Route>
            <Route exact path="/about-us">
              <AboutUs />
            </Route>
            <Route exact path="/privacy-policy">
              <PrivacyPolicy />
            </Route>
            <Route exact path="/terms-and-conditions">
              <TermsAndConditions />
            </Route>
            <Route exact path="/complaint-policy">
              <CompliancePolicy />
            </Route>
            <Route exact path="/feedback">
              <Feedback/>
            </Route>
            <Route exact path="/complaint-policy">
              <CompliancePolicy />
            </Route>
            <Route exact path="/request-data-deletion">
               <RequestDeletion/>
            </Route>
            {/* <Route path="/app" component={AppLayout} />
             */}
          </Switch>
        </BrowserRouter>
        <Footer />
      </AppProvider>

      {/* <AppModal open={cookies.allowcookies ? false : true}>
        <CookieConsent
          onAccept={() => handleCookie(setCookie)}
          onClose={closeWindow}
        />
      </AppModal> */}
      <CookieConsent
        location="bottom"
        buttonText="Yes, I accept Cookies"
        cookieName="IleeroRemit"
        style={{ background: "#2B373B" }}
        buttonStyle={{
          color: "#0a1849",
          fontSize: "13px",
          background: "eff7ff",
        }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.{" "}
        <span style={{ fontSize: "10px" }}>
          We take your privacy seriously.
        </span>
      </CookieConsent>
    </>
  );
};

export default App;
